module.exports = __webpack_public_path__ + "static/pipers_logo-8ba9062c1353d1bf87914ba84b149521.png";